import Axios from 'axios';
import Qs from 'qs';

export default {

    list(params) {
        return Axios.get('/shjf/api/admin/config', {
            params,
            paramsSerializer(params) {
                return Qs.stringify(params);
            }
        })
    },
    edit(params) {
        return Axios.post('/shjf/api/admin/config/set', params)
    }

}